window.addEventListener('load', function () {
  const exceptional_swiper = new Swiper('.subscriptions_mb .swiper', {
    loop: true,
    autoplay: false,
    autoplaySpeed: 5000,
    disableOnInteraction: false,
    // slidesPerView: 1.4,
    spaceBetween: 30,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
  
});
